import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";

export default [
  {
    path: "/wt-task-detail",
    name: "TaskDetail",
    meta: {
      title: "任务详情",
      showHeader: true,
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "star-level" */ "@/views/mine/task-detail/TaskDetail.vue"
      )
  }
];
